import { render, staticRenderFns } from "./MenuSectionsLanding.vue?vue&type=template&id=150696cf&scoped=true&"
import script from "./MenuSectionsLanding.vue?vue&type=script&lang=js&"
export * from "./MenuSectionsLanding.vue?vue&type=script&lang=js&"
import style0 from "./MenuSectionsLanding.vue?vue&type=style&index=0&id=150696cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150696cf",
  null
  
)

export default component.exports